import React, { FC } from 'react';

import { translate } from '@utils/locale';
import CustomButton from '@components/custom-button/CustomButton';

import { FormDualButtonProps } from './types';

const FormDualButton: FC<FormDualButtonProps> = ({
  showCancelOrSaveButton,
  enableEdit,
  onClickCancelButton,
  onClickEditButton,
  isSaveDisabled,
  dataTestId
}) => {
  return (
    <div className="flex flex-row gap-4">
      {showCancelOrSaveButton && (
        <CustomButton
          variant="outlined"
          fullWidth={false}
          onClick={onClickCancelButton}
          label={'Cancel'}
          dataTestId={dataTestId ? `${dataTestId}-cancel-button` : undefined}
        />
      )}
      {enableEdit && (
        <CustomButton
          variant="contained"
          fullWidth={false}
          onClick={onClickEditButton}
          isDisabled={showCancelOrSaveButton ? isSaveDisabled : false}
          label={showCancelOrSaveButton ? translate('save') : translate('edit')}
          dataTestId={dataTestId ? `${dataTestId}-edit-button` : undefined}
          customClassname="hover:bg-gradient-to-r hover:from-denimBlue hover:to-denimBlue"
        />
      )}
    </div>
  );
};

export default FormDualButton;
